// src/IntroPage.js
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

function IntroPage() {
  const navigate = useNavigate()
  
  const handleNext = () => {
    navigate('/onboarding')
  }

  return (
    <div className="intro-screen">
      <p className="tool-subtitle">
        A free tool from Ash Mann,
        find more at{' '}
        <a href="https://ashmann.co/tools" target="_blank" rel="noopener noreferrer">
          ashmann.co/tools{' '}
          <svg className="tool-subtitle-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </p>
      <h1 className="intro-title">How ready are you to make a<br /><span className="highlight">confident digital decision?</span></h1>
      <div className="tool-description-box">
        <h2>The Decision Fit Canvas</h2>
        <p className="intro-lead">
          A free tool designed to help cultural organisations reflect and think more clearly about their needs and specific organisational context, before committing to new digital initiatives, tools or platforms.
        </p>

        <div  className="intro-cards">
          <div className="dashboard-box" style={{ flex: 1, minWidth: '180px', textAlign: 'left' }}>
            <strong>🔍 Reflect on 10 key readiness areas</strong>
          </div>
          <div className="dashboard-box" style={{ flex: 1, minWidth: '180px', textAlign: 'left' }}>
            <strong>⏱ Takes about 10 minutes</strong>
          </div>
        </div>
      </div>

      <p className="intro-note">
        There are no right answers, just honest ones. What's right for someone else, might be wrong for you. 
      </p>



      <button className="intro-start-button" onClick={handleNext}>
        Get started →
      </button>
    </div>
  )
}

export default IntroPage
